/*
 * @Date: 2021-10-19 17:33:29
 * @LastEditors: OBKoro1
 * @LastEditTime: 2022-03-16 15:27:28
 * @FilePath: \ngtc-traceability-admin\src\main.ts
 */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
